import React, { useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import './GoogleLoginMine.css';

const GoogleLoginMine = () => {
  const [user, setUser] = useState(null);

  // Handle Google Login Success
  const handleLoginSuccess = (credentialResponse) => {
    const token = credentialResponse.credential;
    try {
      // Decode the token to get user information
      const decodedUserData = jwtDecode(token);

      // Store token and user data in localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(decodedUserData));

      // Update state with decoded user info
      setUser(decodedUserData);
      console.log("Login successful:", decodedUserData);
      window.location.reload();
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  };

  // Handle Google Login Error
  const handleLoginError = () => {
    console.error("Google login failed");
  };

  return (
    <GoogleOAuthProvider clientId="359488427604-rh726ge8ludntbavtm7ttfgkldlb2vg6.apps.googleusercontent.com">
      <div className="google-login-wrapper">
        <GoogleLogin
          onSuccess={handleLoginSuccess}
          onError={handleLoginError}
          shape="rectangular"
          size="large"
          text="continue_with"
          locale="en"
          useOneTap={true}
        />
      </div>
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginMine;